module.exports = __webpack_public_path__ + "img/honeycomb-texture.1c5b0696.png";